module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "reduced_cost.c12a1781.svg";